"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _convertUnsafeMethod = _interopRequireDefault(require("../../utils/convertUnsafeMethod"));

var _filterDOMProps = _interopRequireDefault(require("../../utils/filterDOMProps"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _class, _class2, _temp;

if (process.env.SCALE_MEDIUM && process.env.SCALE_LARGE) {
  require("../../spectrum-css/fieldgroup/index.css");

  require("../../spectrum-css/fieldgroup/index-diff.css");
} else if (process.env.SCALE_LARGE) {
  require("../../spectrum-css/fieldgroup/index-lg.css");
} else {
  require("../../spectrum-css/fieldgroup/index.css");
}

var RadioGroup = (0, _convertUnsafeMethod["default"])(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(RadioGroup, _Component);

  function RadioGroup(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, RadioGroup);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(RadioGroup).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClickItem", function (value) {
      _this.setSelectedValue(value);
    });
    var selectedValue = props.selectedValue,
        defaultSelectedValue = props.defaultSelectedValue,
        children = props.children;
    var firstSelectedValue;

    _react["default"].Children.forEach(children, function (child) {
      if (child.props.checked) {
        firstSelectedValue = child.props.value;
      }
    });

    var defaultSelected = firstSelectedValue || defaultSelectedValue;
    _this.state = {
      selectedValue: selectedValue != null ? selectedValue : defaultSelected
    };
    return _this;
  }

  (0, _createClass2["default"])(RadioGroup, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if ('selectedValue' in nextProps) {
        this.setState({
          selectedValue: nextProps.selectedValue
        });
      }
    }
    /**
     * When a Radio in the RadioGroup gets focus, set its tabIndex to 0 and the
     * tabIndex to -1 for all the Radio siblings.
     */

  }, {
    key: "onRadioFocus",
    value: function onRadioFocus(event) {
      event.target.tabIndex = 0;
      event.target.parentNode.parentNode.querySelectorAll('input').forEach(function (sibling) {
        if (event.target !== sibling && !sibling.disabled) {
          sibling.tabIndex = -1;
        }
      });
    }
    /**
     * When losing focus and the radioGroup doesn't have a selectedValue, set all
     * the non-disabled siblings tabIndex's to undefined. Some browser treat this as 0.
     */

  }, {
    key: "onRadioBlur",
    value: function onRadioBlur(event) {
      if (!this.state.selectedValue) {
        event.target.parentNode.parentNode.querySelectorAll('input').forEach(function (sibling) {
          if (!sibling.disabled) {
            sibling.tabIndex = undefined;
          }
        });
      }
    }
  }, {
    key: "setSelectedValue",
    value: function setSelectedValue(value) {
      if (!('selectedValue' in this.props)) {
        this.setState({
          selectedValue: value
        });
      }

      this.props.onChange(value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          name = _this$props.name,
          vertical = _this$props.vertical,
          labelsBelow = _this$props.labelsBelow,
          className = _this$props.className,
          children = _this$props.children,
          otherProps = (0, _objectWithoutProperties2["default"])(_this$props, ["name", "vertical", "labelsBelow", "className", "children"]);
      var selectedValue = this.state.selectedValue;
      return _react["default"].createElement("div", (0, _extends2["default"])({
        className: (0, _classnames["default"])('spectrum-FieldGroup', {
          'spectrum-FieldGroup--vertical': vertical
        }, className),
        role: "radiogroup"
      }, (0, _filterDOMProps["default"])(otherProps)), _react["default"].Children.map(children, function (child) {
        var _child$props = child.props,
            value = _child$props.value,
            _onChange = _child$props.onChange,
            disabled = _child$props.disabled;

        if (value == null) {
          throw new Error('Each Radio Button must have a value property');
        }

        var radioGroupOnClick = _this2.handleClickItem.bind(_this2, value);

        var tabIndex = selectedValue === value ? 0 : -1;

        if (disabled || !selectedValue) {
          tabIndex = undefined;
        }

        return _react["default"].cloneElement(child, {
          checked: selectedValue === value,
          labelBelow: labelsBelow,
          name: name,
          tabIndex: tabIndex,
          onFocus: _this2.onRadioFocus.bind(_this2),
          onBlur: _this2.onRadioBlur.bind(_this2),
          onChange: function onChange(checked, e) {
            if (_onChange) {
              _onChange(value);
            }

            radioGroupOnClick(); // Let the RadioGroup change event propagate.

            e.stopPropagation();
          }
        });
      }));
    }
  }]);
  return RadioGroup;
}(_react.Component), (0, _defineProperty2["default"])(_class2, "propTypes", {
  /**
   * Value of the starting selected radio within the group
   */
  defaultSelectedValue: _propTypes["default"].string,

  /**
   * Controlled: Value of the selected radio within the group
   */
  selectedValue: _propTypes["default"].string,

  /**
   * Whether the label is rendered below the radio
   */
  labelBelow: _propTypes["default"].bool,

  /**
   * Render the radio group vertically instead of default horizontal
   */
  vertical: _propTypes["default"].bool
}), (0, _defineProperty2["default"])(_class2, "defaultProps", {
  vertical: false,
  labelsBelow: false,
  onChange: function onChange() {}
}), _temp)) || _class;

exports["default"] = RadioGroup;
RadioGroup.displayName = 'RadioGroup';